/****************************************************
 * Module Name:  pageTitle.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import Constants from "../../utility/constants";

const PageTitle = (key) => {
    document.title = Constants.PAGE_TITLES[key] || "Pansuriya Impex";
};

export default PageTitle;
